import React from "react";

export interface CardProps {
  children: React.ReactNode;
  title?: string;
  mediaUrl?: string;
  youTubeVideoId?: string;
  theme?: CardThemes;
  removePadding?: boolean;
  titleSizeEM?: number;
}

export enum CardThemes {
  blue = "blue",
  yellow = "yellow",
  red = "red",
  green = "green",
  purple = "purple",
  reading_writing = "reading-writing",
  math = "math",
  study_skills = "study-skills",
  test_prep = "test-prep",
  reports_strength = "reports-strength",
  reports_expected = "reports-expected",
  reports_weaknesses = "reports-weaknesses",
  reports_invalid = "reports-invalid",
}
